import React from 'react';
import { StarIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { avatarColors } from '../data/coaches';
import type { CoachProfile, Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  profiles?: CoachProfile[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  profiles = [],
  title = 'What coaches are saying',
  subtitle = 'From volunteer, parent and club coaches running U8–U14 teams.',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-navy' : 'bg-navy-mid';
  return <section aria-label={title} className={`w-full text-white ${bg}`} data-id="element-298" data-mp="2x2w32qu25tna">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-299" data-mp="2s3081h3c9cjv">
        <div className="text-center" data-id="element-300" data-mp="v9ygvdusdzbb">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-301" data-mp="v8wsk7orfgbn">Coach to coach</p>
          <h2 className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-302" data-mp="qav9vnv8xj0p">{title}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-303" data-mp="h4n4idrci3bz">{subtitle}</p>
        </div>

        {profiles.length > 0 && <div className="mt-9 grid gap-6 border-y border-navy-line py-7 sm:grid-cols-2 sm:gap-10" data-id="element-304" data-mp="780jnoz0rc9y">
            {profiles.map((profile, i) => <figure key={profile.name} className="flex gap-4" data-id="element-305" data-mp="c7n0s9hyxco1" data-mpi={i}>
                <Avatar name={profile.name} color={avatarColors[(i + 1) % avatarColors.length]} className="h-12 w-12 flex-none" data-id="element-306" data-mp="zvwgctol946q" />
                <div data-id="element-307" data-mp="q7666ujea9wn">
                  <figcaption data-id="element-308" data-mp="q5v18re7qw3y">
                    <span className="block font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-309" data-mp="q4jwopcy1kbs">
                      {profile.name}
                    </span>
                    <span className="text-xs font-semibold uppercase tracking-wider text-gold" data-id="element-310" data-mp="1itqvlpgb8bxk">
                      {profile.role}
                    </span>
                  </figcaption>
                  <blockquote className="mt-2 text-sm leading-relaxed text-white/75" data-id="element-311" data-mp="1xgpl3evlww9n">
                    “{profile.bio}”
                  </blockquote>
                </div>
              </figure>)}
          </div>}

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-312" data-mp="1ojf89p354z2m">
          {testimonials.map((item, i) => <figure key={item.author} className="flex flex-col rounded-2xl border border-navy-line bg-navy-card p-5 shadow-card" data-id="element-313" data-mp="1ej4vg5l0ptnz" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-314" data-mp="19r3j6jnuo2xy">
                <Avatar name={item.author} src={item.avatar} color={avatarColors[i % avatarColors.length]} className="h-11 w-11" data-id="element-315" data-mp="14sjwgh1fmn4j" />
                <span className="flex gap-0.5" role="img" aria-label="Five out of five" data-id="element-316" data-mp="vrc4shtf8kjf">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-317" data-mp="32gw6un1pqqg4" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-white/90" data-id="element-318" data-mp="37efl3myev382">“{item.quote}”</blockquote>
              <figcaption className="mt-auto pt-4 text-xs text-ink-soft" data-id="element-319" data-mp="3cfv479h12znt">
                <span className="block text-[13px] font-semibold text-white" data-id="element-320" data-mp="3gfdqa8kl5gs8">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}